import NavigationZone from "./NavigationZone";
import { useNavigate } from "react-router-dom";
import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
const AboutPage = () => {
     const getInThere = useNavigate()
    
    const getIn = () => {
        getInThere('/getInTouch')
            }
              const { pathname } = useLocation();
            
              useEffect(() => {
                setTimeout(() => {
                  window.scrollTo(0, 0);
                }, 100); // Delay ensures it's applied after navigation
            
              }, [pathname]);
    return (  
        <div className="about-Page">
            <NavigationZone />
            <div className="stillUnderAbout">
                {/* <div className="imgPart">
            <img className="myPic2" src="bigLit.JPG" alt="Description of image" />
            </div> */}
      <h1 className="yunus">Ayomide Lit</h1>
      <div className="styleThem">
      <div className="boxThemAll">
       <p className="nameMi">SW Developer / Lit-Cut</p>
       <p className="infos">
         As an independent software developer based in Lagos, I bring a unique blend of creativity, technical expertise, and self-reliance to the tech space. My journey has been characterized by a dedication to learning, problem-solving, and delivering results without constant supervision.
         Being independent means I excel at taking ownership of projects, from ideation to execution. I am skilled at researching solutions, troubleshooting complex challenges, and managing timelines effectively, ensuring that projects are delivered on schedule and to a high standard.
         Lagos, a city known for its vibrant energy and resourcefulness, has played a significant role in shaping my approach to development. The fast-paced environment has taught me to adapt quickly, think critically, and remain solution-focused in diverse situations.</p>
            </div>
            </div>
        </div>
        <div className="getIN2">
        <div className="getIN" onClick={getIn}>
            <p>Get In Touch</p>
        </div>
        </div>
        </div>
    );
}
 
export default AboutPage;
